// export const apiBaseUrl = 'http://localhost:3000'
export const apiBaseUrl = `${window.location.protocol}//interactivevideo.swisstxt.ch/node/cling`
export const pinwallApiUrl = 'https://pinwall.swisstxt.ch'
export const pinwallApiKey = '80766691-90fd-479c-90f0-49ccd10668f5'
export const pinwallUrl = 'http://pinwall.swisstxt.ch/#/pinwall/'
